<script setup>
import { computed, ref, watch } from 'vue';
import PublicationCalendar from '../publications/PublicationCalendar.vue';
import { statuses } from './model';

const props = defineProps({
  tasks: { type: Array, default: () => [] },
  disabled: { type: Boolean, default: false },
  refreshKey: { type: Number, default: 0 },
});
const emit = defineEmits(['select', 'create', 'range']);
let lastRange = null;
function receiveRange(range) {
  date.value = range.date;
  lastRange = range;
  emit('range', range);
}
watch(
  () => props.refreshKey,
  () => {
    if (lastRange) emit('range', lastRange);
  }
);
const view = ref('month');
const date = ref(
  new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Moscow',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date())
);
const events = computed(() =>
  props.tasks.map(task => ({
    id: task.id,
    title: task.text,
    start: `${task.plannedAt}:00+03:00`,
    extendedProps: { run: task, status: statuses[task.state] },
  }))
);
</script>

<template>
  <PublicationCalendar
    :events="events"
    :view="view"
    :date="date"
    :disabled="disabled"
    timezone="Europe/Moscow"
    @view-change="view = $event"
    @range-change="receiveRange"
    @event-click="emit('select', $event)"
    @create="!disabled && emit('create')"
    @slot-click="!disabled && emit('create')"
  />
</template>
